import alert_mixin from '@/utils/mixins/alert_mixin';
import template_question_mapping_data_methods from './template_question_mapping_data_methods';
import template_question_mapping_computed, {
  create_template_question_mapping_data,
} from './template_question_mapping_helpers';
import template_question_mapping_view_methods from './template_question_mapping_view_methods';

export default {
  name: 'TemplateQuestionMapping',
  mixins: [alert_mixin],
  data: create_template_question_mapping_data,
  computed: template_question_mapping_computed,
  watch: {
    '$route.query': {
      handler() {
        this.reload_all();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...template_question_mapping_view_methods,
    ...template_question_mapping_data_methods,
  },
};
